import React from 'react';
import classNames from 'classnames';

import { Button } from 'app/design-system/components/Button';
import { Icon } from 'app/design-system/components/Icon';
import { Spinner } from 'app/design-system/components/Spinner';
import { useTranslation } from 'app/lang';

import dictionary from './TelegramButton.dictionary.json';

import styles from './TelegramButton.module.scss';

export type TelegramButtonProps = {
  loading?: boolean;
  onClick?: () => void;
  className?: string;
};

export const TelegramButton = ({ loading, onClick, className }: TelegramButtonProps) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!loading) {
      onClick?.();
    }
  };

  return (
    <Button
      className={classNames(styles.root, className)}
      disabled={loading}
      onClick={handleClick}
      data-ga-event="logInTelegram">
      {loading ? (
        <Spinner size={24}
                 white
                 className={styles.spinner} />
      ) : (
        <>
          <Icon icon="telegram" />
          {t(dictionary.logIn)}
        </>
      )}
    </Button>
  );
};
